import React from 'react'
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { useState } from 'react';
function Editbrand() {
    const {id} = useParams();
    const [name, setName] = useState('');
    const [code, setCode] = useState('');
    const [active, setActive] = useState(true);
    const [img, setimg] = useState('');
    const editdata =  (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append('Name', name);
        formData.append('Code', code);
        formData.append('Active', active);
        formData.append('img',img);
        axios.put(process.env.REACT_APP_API_URL+`/api/brands/${id}`,formData ).then((response) => {
            console.log(response);
            window.location.href = "/brand";
        }
        ).catch((error) => {
            console.error(error);
        });
    }
  return (
    <>
    <div className='flex justify-center'>
                    <form  className='bg-white w-1/2 ' onSubmit={editdata} >
                        <h1 className="text-2xl font-semibold text-gray-900">Edit Brand</h1>
                        <div className="flex flex-col">
                        <label
                            htmlFor="brand"
                            className="block text-sm font-medium text-gray-700 mt-4"
                        >
                            Brand
                        </label>
                        <input
                            type="text"
                            name="brand"
                            id="brand"
                            autoComplete="brand"
                            className="py-2 px-4 border-2 border-gray-300 focus:outline-none focus:border-blue-500 rounded-md"
                            onChange={(e)=>setName(e.target.value)}
                            placeholder='Enter Brand Name'
                        ></input>
                        </div>
                        <div className="flex flex-col">
                        <label
                            htmlFor="code"
                            className="block text-sm font-medium text-gray-700 mt-4"
                        >
                            Code
                        </label>
                        <input
                            type="text"
                            name="code"
                            id="code"
                            autoComplete="code"
                            className="py-2 px-4 border-2 border-gray-300 focus:outline-none focus:border-blue-500 rounded-md"
                            placeholder='Enter Brand Code'
                            onChange={(e)=>setCode(e.target.value)}
                        ></input>
                        </div>
                        <div className="flex flex-col">
                        <label
                            htmlFor="active"
                            className="block text-sm font-medium text-gray-700 mt-4"
                        >
                            Active
                        </label>
                        <select
                            name="active"
                            id="active"
                            className="py-2 px-4 border-2 border-gray-300 focus:outline-none focus:border-blue-500 rounded-md"
                            onChange={(e)=>setActive(e.target.value)}
                        >
                            <option value="true">Active</option>
                            <option value="false">Disabled</option>
                        </select>
                        <label
                                htmlFor="brand"
                                className="block text-sm font-medium text-gray-700 mt-4"
                            >
                                Logo
                            </label>
                            <input
                                type="file"
                                name="logo"
                                id="logo"
                                autoComplete="logo"
                                onChange={(e)=>setimg(e.target.files[0])}
                                className="py-2 px-4 border-2 border-gray-300 focus:outline-none focus:border-blue-500 rounded-md"
                            ></input>
                        </div>
                        <button
                        type="submit"
                        className="mt-4 rounded-md bg-black px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-black/80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-black"
                        >
                        Save Changes
                        </button>
                    </form>
                </div>

    </>
  )
}

export default Editbrand